/**
 * Class List Filters
 * Tab-based filters for class list (All, Draft, Scheduled, Active, Ended)
 */

import { Tabs, TabsList, TabsTrigger } from '../ui/tabs';
import type { ClassStatus } from '@cloak-next/shared';

interface ClassListFiltersProps {
  activeFilter: ClassStatus | 'all';
  onFilterChange: (filter: ClassStatus | 'all') => void;
  classCounts?: {
    all: number;
    draft: number;
    scheduled: number;
    active: number;
    ended: number;
  };
}

export function ClassListFilters({
  activeFilter,
  onFilterChange,
  classCounts,
}: ClassListFiltersProps) {
  return (
    <Tabs value={activeFilter} onValueChange={(value) => onFilterChange(value as ClassStatus | 'all')}>
      <TabsList>
        <TabsTrigger value="all">
          All
          {classCounts && classCounts.all > 0 && (
            <span className="ml-2 rounded-full bg-muted px-2 py-0.5 text-xs">
              {classCounts.all}
            </span>
          )}
        </TabsTrigger>
        <TabsTrigger value="draft">
          Draft
          {classCounts && classCounts.draft > 0 && (
            <span className="ml-2 rounded-full bg-muted px-2 py-0.5 text-xs">
              {classCounts.draft}
            </span>
          )}
        </TabsTrigger>
        <TabsTrigger value="scheduled">
          Scheduled
          {classCounts && classCounts.scheduled > 0 && (
            <span className="ml-2 rounded-full bg-muted px-2 py-0.5 text-xs">
              {classCounts.scheduled}
            </span>
          )}
        </TabsTrigger>
        <TabsTrigger value="active">
          Active
          {classCounts && classCounts.active > 0 && (
            <span className="ml-2 rounded-full bg-muted px-2 py-0.5 text-xs">
              {classCounts.active}
            </span>
          )}
        </TabsTrigger>
        <TabsTrigger value="ended">
          Ended
          {classCounts && classCounts.ended > 0 && (
            <span className="ml-2 rounded-full bg-muted px-2 py-0.5 text-xs">
              {classCounts.ended}
            </span>
          )}
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
